module.exports = __webpack_public_path__ + "media/dashboard/assets/images/window-maximize-2bb16f56aa7c2dfea6aa62c961a23ca4.svg";